import { apiRequest, queryString } from '@/api/utils';

const endpoint = 'visitas';

export default {
  create: ({ chargeId, data }) => apiRequest.post(`encargos/${chargeId}/${endpoint}`, data),

  getAll({
    chargeCode,
    clientId,
    complete,
    endDate,
    include,
    notified,
    page,
    perPage,
    startDate,
    town,
    agendada,
  } = {}) {
    const params = {
      'filter[encargo.codigo]': chargeCode,
      'filter[encargo.inmueble_poblacion]': town,
      'filter[encargo.empresasclientes_id]': clientId,
      'filter[completa]': complete,
      'filter[notificada_completa]': notified,
      'filter[notificada_agenda]': agendada,
      include,
      page,
      per_page: perPage,
      fecha_hora_fin: endDate,
      fecha_hora_ini: startDate,
    };

    return apiRequest.get(`${endpoint}?${queryString.stringify(params)}`);
  },

  getAllByAssessor: id => apiRequest.get(`${endpoint}/${id}`),

  getAllUncomplete({ assessorId, page, perPage } = {}) {
    const params = {
      page,
      per_page: perPage,
    };

    return apiRequest.get(`encargos/visitasNoCompletas/${assessorId}?${queryString.stringify(params)}`);
  },

  preCreate: id => apiRequest.get(`encargos/${id}/${endpoint}/create`),

  setComplete: id => apiRequest.put(`${endpoint}/${id}`),

  setCompleteByAdmin: data => apiRequest.post(`${endpoint}/completar`, [{ encargos: data }]),

  setCompleteTimestamp: data => apiRequest.post(`${endpoint}/completarconhora`, [{ data }]),

  unschedule: id => apiRequest.delete(`${endpoint}/${id}`),

  update: ({ id, data }) => apiRequest.patch(`${endpoint}/${id}`, data),

};
